import React, {Component} from 'react';
import { Link , Redirect} from 'react-router-dom';
import {withAlert} from 'react-alert'
import axios from 'axios';
import {config} from '../config';
import Loading from "./Loading";



class Forgetpass extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isSend: false,
            loading:false
        };
        this.handleGetCode = this.handleGetCode.bind(this);
        this.alert = false;
    }


    handleGetCode() {
        this.setState({loading: true});
        let phone = document.getElementById('mobile').value.replace(/۰/g,'0').replace(/۱/g,'1').replace(/۲/g,'2').replace(/۳/g,'3').replace(/۴/g,'4').replace(/۵/g,'5').replace(/۶/g,'6').replace(/۷/g,'7').replace(/۸/g,'8').replace(/۹/g,'9');

        let data ={
            'mobile' : phone
        };

        let req = {
            method: 'post',
            url: config.baseUrl + 'api/v1/auth/password/forget',
            data: data
        };
        axios(req
        ).then((resp) => {
            this.setState({loading: false});
            if(resp.data.status === 1) {
                this.setState({
                    isSend: true,
                });
            }
        }).catch(err => {
            this.setState({loading: false});
            this.props.alert.error(err.response.data.errors ? err.response.data.errors[0].message : "شماره موبایل وارد شده در سیستم وجود ندارد.")
        });


    }

    render() {
        return (
            <div className='App form-group'>
                <Loading loading={this.state.loading}/>
                <div className='img-div col-lg-9 col-md-8 col-sm-6 hidden-xs'>
                        <span>
                        </span>
                </div>
                <div className='left-div col-lg-3 col-md-4 col-sm-6 col-xs-12'>
                        <div>
                        <h5>فراموشی رمز عبور</h5>
                        <p className='blue'>جهت دریافت رمز عبور، شماره موبایل خود را وارد کنید</p>
                        <span className='line'></span>
                            <form>
                                <div className='input-div '>
                                    <h5>شماره موبایل</h5>
                                    <div className='input-group'>
                                        <i className='icon-phone inputIcon'></i>
                                        <input id='mobile' className='input num' placeholder='09...'/>
                                    </div>
                                </div>

                            </form>
                        <div className='button-div blueBtn'>
                            {this.state.isSend ? <Redirect
                                to={
                                {
                                pathname: '/Resetpass',
                                state: {
                                    phone: document.getElementById('mobile').value.replace(/۰/g,'0').replace(/۱/g,'1').replace(/۲/g,'2').replace(/۳/g,'3').replace(/۴/g,'4').replace(/۵/g,'5').replace(/۶/g,'6').replace(/۷/g,'7').replace(/۸/g,'8').replace(/۹/g,'9'),
                                }
                            }}/> :''}
                            <button onClick={this.handleGetCode}>
                                <h5>ادامه</h5>
                            </button>
                        </div>
                        <div className='button-div pinkBtn'>
                            <Link to={'/login'}><button><h5>انصراف</h5></button></Link>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

export default withAlert(Forgetpass);